import React from 'react';

import MenuButton from "../../shared/items/controls/menuButton"
import Menu from "./menu"

import styles from "./menuWrapper.module.scss"

const MenuWrapper = () => {
  return (
    <div className={styles.menuWrapper}>
      <div className={styles.container_menuButton}>
        <MenuButton />
      </div>

      <div className={styles.container_menu}>
        <Menu/>
      </div>
    </div>
  )
}

export default MenuWrapper;